<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <router-link :to="{ path: '/preset_lists/new' }">
                <md-button class="md-info">Create Category</md-button>
            </router-link>
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>assignment</md-icon>
                    </div>
                    <h4 class="title">Presets Categories</h4>
                </md-card-header>
                <md-card-content>
                    <md-table
                            :value="presets"
                            :md-sort.sync="currentSort"
                            :md-sort-order.sync="currentSortOrder"
                            :md-sort-fn="customSort"
                            class="paginated-table table-striped table-hover"
                    >
                        <md-table-toolbar>
                            <md-field>
                                <label>Per page</label>
                                <md-select v-model="handleProps.perPage" >
                                    <md-option
                                            v-for="item in pagination.perPageOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                    >
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field>
                                <md-input
                                        type="search"
                                        class="mb-3"
                                        clearable
                                        style="width: 200px"
                                        placeholder="Search records"
                                        v-model="handleProps.searchQuery"
                                >
                                </md-input>
                            </md-field>
                        </md-table-toolbar>
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
                            <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
                            <md-table-cell md-label="Type">{{ item.preset_type }}</md-table-cell>
                            <md-table-cell md-label="Actions" class="text-right">
                                <md-button
                                        class="md-just-icon md-warning md-simple"
                                        @click="$router.push({name: 'Edit Category', params: { id: item.id } })"
                                >
                                    <md-icon>edit</md-icon>
                                </md-button>
                                <md-button
                                        class="md-just-icon md-danger md-simple"
                                        @click.native="showDeleteConfirm(item)"
                                >
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                    <div class="footer-table md-table">
                        <table>
                            <tfoot>
                            <tr>
                                <th
                                        v-for="item in footerTable"
                                        :key="item.name"
                                        class="md-table-head"
                                >
                                    <div class="md-table-head-container md-ripple md-disabled">
                                        <div class="md-table-head-label">
                                            {{ item }}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                        </p>
                    </div>
                    <pagination
                            class="pagination-no-border pagination-success"
                            v-model="handleProps.currentPage"
                            :per-page="handleProps.perPage"
                            :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
    import { Pagination } from "@/components";
    import { showConfirmationDialog } from '@/components/ActionConfirm';
    export default {
        components: { Pagination },
        computed: {
            to() {
                let highBound = this.from + this.handleProps.perPage;
                if (this.total < highBound) {
                    highBound = this.total;
                }
                return highBound;
            },
            from() {
                return this.handleProps.perPage * (this.handleProps.currentPage - 1);
            },
            total() {
                return  this.pagination.total;
            }
        },
        data() {
            return {
                currentSort: "name",
                currentSortOrder: "asc",
                pagination: {
                    perPage: 5,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                    total: 0
                },
                footerTable: ["Id", "Name", "Type", "Actions"],
                searchQuery: "",
                propsToSearch: ["name"],
                presets: [],
                handleProps: {
                    searchQuery: "",
                    currentPage: 1,
                    perPage: 5
                }
            };
        },
        methods: {
            showDeleteConfirm(presetList) {
                showConfirmationDialog(() => this.deletePresetList(presetList))
            },
            deletePresetList: function (presetList) {
                this.$http.secured.delete(`/v1/preset_lists/${presetList.id}`)
                    .then(() => {
                        this.presets.splice(this.presets.indexOf(presetList), 1)
                    });
            },
            customSort(value) {
                return value.sort((a, b) => {
                    const sortBy = this.currentSort;
                    if (this.currentSortOrder === "desc") {
                        return a[sortBy].localeCompare(b[sortBy]);
                    }
                    return b[sortBy].localeCompare(a[sortBy]);
                });
            },
            setData(response) {
                this.presets = response.data.preset_lists;
                this.pagination.total = response.data.meta.total
            }
        },
        created() {
            this.$http.secured.get(`/v1/preset_lists?page=${this.handleProps.currentPage}&per=${this.handleProps.perPage}&q=${this.handleProps.searchQuery}`)
                .then(this.setData)
                .catch(error => alert(error))
        },
        mounted() { },
        watch: {
            handleProps: {
                handler() {
                    this.$http.secured.get(`/v1/preset_lists?page=${this.handleProps.currentPage}&per=${this.handleProps.perPage}&q=${this.handleProps.searchQuery}`)
                        .then(this.setData)
                        .catch(error => alert(error))
                },
                deep: true
            }
        }
    };
</script>

<style lang="css" scoped>
    .md-card .md-card-actions{
        border: 0;
        margin-left: 20px;
        margin-right: 20px;
    }
</style>

